var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFuel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2,
  d: "M20.315 22.085h-2.752V6.296a.507.507 0 0 0-.507-.507h-1.123V4.667c0-.73-.593-1.323-1.322-1.323s-1.322.594-1.322 1.323v1.122h-2.245V3.852A2.955 2.955 0 0 0 8.093.9 2.955 2.955 0 0 0 5.14 3.852v12.222c0 .28.227.507.507.507H6.77v5.504H4.02a.507.507 0 1 0 0 1.015h16.296a.507.507 0 1 0 0-1.015zM14.304 4.667a.308.308 0 0 1 .614 0v1.122h-.614zm-8.148 10.9V3.852a1.94 1.94 0 0 1 1.937-1.937 1.94 1.94 0 0 1 1.937 1.937v1.937H7.278a.51.51 0 0 0-.508.507v9.27h-.614zm1.63 6.518V6.804h8.762v15.281z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2,
  d: "M15.426 7.418H8.907a.51.51 0 0 0-.507.508V12c0 .28.227.507.507.507h6.519c.28 0 .507-.227.507-.507V7.926a.507.507 0 0 0-.507-.508zm-.507 4.074H9.415V8.433h5.504zm.507 1.63h-.815a.507.507 0 1 0 0 1.015h.815a.507.507 0 1 0 0-1.015z"
})));
export default SvgFuel;